import { FieldFilter } from 'ps-components/FieldFilters/IFieldFilter';

export enum JobsSelection {
  ALL_JOBS = 'all',
  SELECT_JOBS = 'select'
}

export enum DataCutPriority {
  DEFAULT = 'default',
  GROUP_SPECIFIC = 'group_specific',
  RULES_BASED_PRICING = 'rules_based_pricing'
}

export enum Methodology {
  MATCH_PRIORITY = 'match_priority',
  DATA_CUT_PRIORITY = 'data_cut_priority'
}

export enum RuleStep {
  SELECT_JOBS = 'select-jobs',
  DATA_CUT_PRIORITIES = 'data-cut-priorities',
  METHODOLOGY = 'methodology'
}

export interface PricingRule {
  id: number;
  name: string;
  organizationId: number;
  jobsSelection: JobsSelection;
  jobsFilter: typeof FieldFilter[];
  dataCutPriority: DataCutPriority;
  dataCutPrioritySelection: string;
  methodology: Methodology;
  incumbentsMinimum: number;
  companiesMinimum: number;
  marketDataElements: Array<string>;
  globalJobPricingVersionId: number;
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
}

interface DataCutOptions {
  label: string;
  type: DataCutPriority;
  value?: string;
}
export interface DataCutOption extends DataCutOptions {
  options?: DataCutOptions[];
}
